import { render, staticRenderFns } from "./DocumentFeed.vue?vue&type=template&id=4c219337&scoped=true&"
import script from "./DocumentFeed.vue?vue&type=script&lang=ts&"
export * from "./DocumentFeed.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentFeed.vue?vue&type=style&index=0&id=4c219337&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c219337",
  null
  
)

export default component.exports